// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        numberFilterTree: 2
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'onSaleClass': 'on-sale',
 
    'soldOutLabelHtml': '<div class="badge badge--sold-out"><span class="badge-label">' + bcSfFilterConfig.label.sold_out + '</span></div>',

    // Grid
    'productGridItemHtml': '<div class="grid-item {{gridItemWidthClass}} {{soldOutClass}} {{onSaleClass}}">' +
                                '<a href="{{itemUrl}}" class="product-grid-item">' +
                                    '<div class="product-grid-image">' +
                                        '<div class="product-grid-image--centered">' +
                                            '{{itemSoldOutLabel}}' +
                                            '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
                                        '</div>' +
                                    '</div>' +
                                    '<p>{{itemTitle}}</p>' +
                                    '<div class="product-item--price">' +
                                        '{{itemPrice}}' +
                                    '</div>' +
                                '</a>' +
                            '</div>',

    // List
    'productListItemHtml': '<div class="grid-item {{soldOutClass}} {{onSaleClass}}">' +
                                '<a href="{{itemUrl}}" class="product-grid-item product-list-item">' +
                                    '<div class="grid">' +
                                        '<div class="grid-item large--one-fifth medium--one-third">' +
                                            '<div class="product-list-image">' +
                                                '{{itemSoldOutLabel}}' +
                                                '<img src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
                                            '</div>' +
                                        '</div>' + 
                                        '<div class="grid-item large--three-fifths medium--two-thirds">' +
                                            '<p class="h6">{{itemTitle}}</p>' +
                                            '<div class="rte">' +
                                                '<p>{{itemDescription}}</p>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="grid-item large--one-fifth medium--two-thirds">' +
                                            '<div class="product-item--price text-center">' +
                                                '{{itemPrice}}' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</a>' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<div class="form-horizontal"><label>' + bcSfFilterConfig.label.sorting + '</label><select>{{sortingItems}}</select></div>',
  
    // Display Type Template
    'displayTypeHtml' : '<div class="collection-view"><a href="{{gridUrl}}" class="bc-sf-filter-display-grid" title="Grid view" data-view="grid"><span class="icon icon-collection-view-grid"></span></a><a href={{listUrl}} class="bc-sf-filter-display-list" title="List view" data-view="list"><span class="icon icon-collection-view-list"></span></a></div>',
    
    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/" title="' + bcSfFilterConfig.label.breadcrumb_home_link + '">' + bcSfFilterConfig.label.breadcrumb_home + '</a>' +
                      ' <span class="divider" aria-hidden="true">&rsaquo;</span>' +
                      ' {{currentCollection}}'
};

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add a specific class for grid item
    var gridItemWidthClass = '';
    var imageSize = '600x600';
    switch(bcSfFilterConfig.custom.products_per_row) {
        case 2: gridItemWidthClass = 'medium--one-half large--one-half'; imageSize = '540x600'; break;
        case 3: gridItemWidthClass = 'small--one-half medium--one-third large--one-third';  imageSize = '345x550'; break;
        case 4: gridItemWidthClass = 'small--one-half medium--one-quarter large--one-quarter'; imageSize = '250x'; break;
        case 5: gridItemWidthClass = 'small--one-half medium--one-fifth large--one-fifth'; imageSize = '195x'; break;
    }
    itemHtml = itemHtml.replace(/{{gridItemWidthClass}}/g, gridItemWidthClass);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var onSaleClass = onSale ? bcSfFilterTemplate.onSaleClass : '';
    itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

    // Add soldOut label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], imageSize) : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Price
    var itemPriceHtml = '<span class="h1 medium--left">';
    if (onSale) {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price  + '</span>';
    } else {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
    }
    itemPriceHtml += buildPriceHtml(data.price_min);
    if (onSale && bcSfFilterConfig.custom.show_compare_at_price) {
        itemPriceHtml += ' <small><s><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
        itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
        itemPriceHtml += '</s></small>';
    }
    itemPriceHtml += '</span>';
    if (onSale && bcSfFilterConfig.custom.product_show_saved_amount) {
        var class1 = bcSfFilterConfig.custom.show_compare_at_price ? ' medium--right ' : '';
        var class2 = bcSfFilterConfig.custom.product_reviews_enable ? ' has-reviews' : '';
        var savePrice = data.compare_at_price_min - data.price_min;
        if (bcsffilter.moneyFormat.indexOf('money') != -1) {
            savePrice = this.formatMoney(savePrice, this.moneyFormat);
        } else {
            if (savePrice > 1000) {
                if (bcsffilter.moneyFormat.indexOf('{{amount}}') != -1 && bcsffilter.moneyFormat.indexOf('.') != -1) {
                    savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
                } else if (bcSfFilterConfig.shop.money_format.indexOf('{{amount}}') != -1) {
                    savePrice = this.formatMoney(savePrice, this.moneyFormat).split('.')[0];
                } else if (bcSfFilterConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1) {
                    savePrice = this.formatMoney(savePrice, this.moneyFormat).split(',')[0];
                }
            } else {
                savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
            }
        }
        itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
        itemPriceHtml += bcSfFilterConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
        itemPriceHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

BCSfFilter.prototype.buildProductListItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productListItemHtml;

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
  
    // Add onSale class
    var onSaleClass = onSale ? bcSfFilterTemplate.onSaleClass : '';
    itemHtml = itemHtml.replace(/{{onSaleClass}}/g, onSaleClass);

    // Add soldOut label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], '600x600') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Price
    var itemPriceHtml = '<span class="h1 medium--left">';
    if (onSale) {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.sale_price  + '</span>';
    } else {
        itemPriceHtml += '<span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
    }
    itemPriceHtml += buildPriceHtml(data.price_min);
    if (onSale && bcSfFilterConfig.custom.show_compare_at_price) {
        itemPriceHtml += ' <small><s><span class="visually-hidden">' + bcSfFilterConfig.label.regular_price + '</span>';
        itemPriceHtml += buildPriceHtml(data.compare_at_price_min);
        itemPriceHtml += '</s></small>';
    }
    itemPriceHtml += '</span>';
    if (onSale && bcSfFilterConfig.custom.product_show_saved_amount) {
        var class1 = bcSfFilterConfig.custom.show_compare_at_price ? ' medium--right ' : '';
        var class2 = bcSfFilterConfig.custom.product_reviews_enable ? ' has-reviews' : '';
        var savePrice = data.compare_at_price_min - data.price_min;
        if (bcsffilter.moneyFormat.indexOf('money') != -1) {
            savePrice = this.formatMoney(savePrice, this.moneyFormat);
        } else {
            if (savePrice > 1000) {
                if (bcsffilter.moneyFormat.indexOf('{{amount}}') != -1 && bcsffilter.moneyFormat.indexOf('.') != -1) {
                    savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
                } else if (bcsffilter.moneyFormat.indexOf('{{amount}}') != -1) {
                    savePrice = this.formatMoney(savePrice, this.moneyFormat).split('.')[0];
                } else if (bcsffilter.moneyFormat.indexOf('{{amount_with_comma_separator}}') != -1) {
                    savePrice = this.formatMoney(savePrice, this.moneyFormat).split(',')[0];
                }
            } else {
                savePrice = this.formatMoney(savePrice, this.moneyFormat, true);
            }
        }
        itemPriceHtml += '<span class="sale-tag' + class1 + class2 + '">';
        itemPriceHtml += bcSfFilterConfig.label.save_price.replace(/{{ saved_amount }}/g, savePrice);
        itemPriceHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Description
    var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    itemDescription = (itemDescription.split(" ")).length > 40 ? itemDescription.split(" ").splice(0, 40).join(" ") + '...' : itemDescription.split(" ").splice(0, 40).join(" ");
    itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

function buildPriceHtml(price) {
    var customPrice = bcsffilter.formatMoney(price, bcsffilter.moneyFormat);
    if (bcsffilter.moneyFormat.indexOf('money') == -1 || bcsffilter.moneyFormat.indexOf('.') == -1) {
        if (bcSfFilterConfig.custom.superscript_decimals) {
            if (bcsffilter.moneyFormat.indexOf('{{amount}}') !== -1 || bcsffilter.moneyFormat.indexOf('{{ amount }}') !== -1) {
                customPrice = customPrice.replace('.', '<sup>') + '</sup>';
            } else if (bcsffilter.moneyFormat.indexOf('{{amount_with_comma_separator}}') !== -1 || bcsffilter.moneyFormat.indexOf('{ amount_with_comma_separator }}') !== -1) {
                customPrice = customPrice.replace(',', '<sup>') + '</sup>';
            }
        }
    }
    var html = '<small aria-hidden="true">' + customPrice + '</small>';
    html += '<span class="visually-hidden">' + bcsffilter.formatMoney(price, bcsffilter.moneyFormat) + '</span>';
    return html;
}

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function(data) {
    for (var k in data) {
        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.bottomPagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Create page items array
        var beforeCurrentPageArr = [];
        for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
            beforeCurrentPageArr.unshift(iBefore);
        }
        if (currentPage - 4 > 0) {
            beforeCurrentPageArr.unshift('...');
        }
        if (currentPage - 4 >= 0) {
            beforeCurrentPageArr.unshift(1);
        }
        beforeCurrentPageArr.push(currentPage);

        var afterCurrentPageArr = [];
        for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
            afterCurrentPageArr.push(iAfter);
        }
        if (currentPage + 3 < totalPage) {
            afterCurrentPageArr.push('...');
        }
        if (currentPage + 3 <= totalPage) {
            afterCurrentPageArr.push(totalPage);
        }

        // Build page items
        var pageItemsHtml = '';
        var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
        for (var iPage in pageArr) {
            if (pageArr[iPage] == '...') {
                pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
            } else {
                pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
            }
            pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
            pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
        }
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

        jQ(this.selector.bottomPagination).html(paginationHtml);
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
    if (jQ(this.selector.topDisplayType).length > 0) {
        var itemHtml = bcSfFilterTemplate.displayTypeHtml;
        itemHtml = itemHtml.replace(/{{gridUrl}}/g, this.buildToolbarLink('display', 'list', 'grid'));
        itemHtml = itemHtml.replace(/{{listUrl}}/g, this.buildToolbarLink('display', 'grid', 'list'));
        jQ(this.selector.topDisplayType).html(itemHtml);

        // Active current display type
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('collection-view--active');
        jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('collection-view--active');
        if (this.queryParams.display == 'list') {
            jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('collection-view--active');
        } else if (this.queryParams.display == 'grid') {
            jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('collection-view--active');
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
        var breadcrumbHtml = bcSfFilterTemplate.breadcrumbHtml;
        var colInfo = colData.collection;
        var currentCollectionHtml = '';
        if (Array.isArray(bcSfFilterConfig.general.current_tags) && bcSfFilterConfig.general.current_tags.length > 0) {
            currentCollectionHtml += ' <a href="/collections/' + colInfo.handle + '">' + colInfo.title + '</a>';
            currentCollectionHtml += ' <span class="divider" aria-hidden="true">&rsaquo;</span>'
            currentCollectionHtml += ' <span>' + current_tags.join(' + ') + '</span>';
        } else {
            currentCollectionHtml += ' <span>' + colInfo.title + '</span>';
        }
        breadcrumbHtml = breadcrumbHtml.replace(/{{currentCollection}}/g, currentCollectionHtml);
        jQ('.breadcrumb').html(breadcrumbHtml);
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data) {};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  this.buildRobotsMetaTag();
	/* Start Initialize BC QuickView */
	if (typeof(bcQuickView) !== 'undefined') {
		if(typeof(bcQuickViewParams) !== 'undefined') {
			bcQuickView.init(bcQuickViewParams);
		} else {
			bcQuickView.init();
		}
	}
	/* End Initialize BC QuickView */
};
/* boost-start-2.4.2 */
/* If you upgrade the lib to the version >= 2.4.2, please comment the functions below out */
BCSfFilter.prototype.buildRobotsMetaTag = function(data) { var self = this; var metaContent = 'meta[content="noindex,nofollow"]'; if (self.checkIfPFParamsPartOfAURL() === true && jQ('head').find( metaContent).length === 0) { var m = document.createElement('meta'); m.name = 'robots'; m.content = 'noindex,nofollow'; document.head.appendChild(m); } }; BCSfFilter.prototype.checkIfPFParamsPartOfAURL = function() { var self = this; if (window.location.search.length > 0 && window.location.search.indexOf('pf_') > 0) { return true; } return false; };
/* boost-end-2.4.2 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
